import React, { useState } from 'react'
import './styles.scss'
import close from './../../images/close-white.svg'
import Heading from './../heading/Heading';
import Text from './../text/Text';
import loading from './../../images/loading-white-ico.svg';
import arrow from './../../images/arrow.svg';
import Button from './../buttons/Button';
import { useSelector } from 'react-redux'
import { useNavigate } from "react-router";

const ModalLastStep = ( props ) => {
    let [ blockedBtn, setBlockedBtn ] = useState(false);
    let isShop = useSelector(state => state.isShop)
    let navigate = useNavigate();

    const clickedBtn = async () => {
        await setBlockedBtn(true);
        await props.setFunction();
    }
    return (
        <div className="static-modal">
            <div className="modal extra-small max-width">
                <div className="last-step">
                    <div className="icons-wrap" onClick={ () => props.closeModal() }>
                        <img src={ close } alt="Zamknij" onClick={ () => props.closeModal() } />
                    </div>
                    <div className="content">
                        <Heading title={`Information`} />
                        {props.productPrice >= 50000 &&
                            <Text text={`The above-mentioned calculation will be processed by our credit department.</br>Due to the high value, additional documents or information may be required.</br>Our sales representative will reach out to discuss the details.`} />
                        }
                        {props.productPrice < 50000 &&
                            <Text text={`Thank you for submitting your application!</br>We will contact you soon.`} />
                        }
                        <Button title="Finish"
                                    arrow={ true } 
                                    class="black"
                                    size="full"
                                    setFunction={ () => navigate(isShop ? '/shop':'/')} />
                        {/* <div className="btn-wrap end">
                            <div className={"btn blue" + (props.finishLoading ? ' loading' : '')}  onClick={ () => !blockedBtn && clickedBtn() }>
                                <span> { props.btnText } </span>
                                <img className="upload-ico" src={ (props.finishLoading ? loading : arrow) } alt="finish form"/>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalLastStep;